import Base from './Base';

type SearchGroupResults<T> = {
    id: number;
    label: string;
    ranking: number[];
} & ApiListResponse<T>;

export type SearchResults =
    | SearchGroupResults<Document>
    | SearchGroupResults<Author>
    | SearchGroupResults<Collection>;

class Search extends Base {
    get(search, query = null, opts = null) {
        return this.getJSONWithSession<SearchResults[]>(
            '/search',
            {
                q: search,
                authors_count: 3,
                ...query,
            },
            opts,
        );
    }
}

export default Search;
